import React, { useEffect } from "react"
import ReactDOM from 'react-dom';

export type OverlayProps = {
	backdrop?: boolean
	children?: React.ReactNode
	onBackgroundClick?: () => void
}

const modalRoot = document.getElementById('modal-root')
export const Overlay: React.FC<OverlayProps> = (props) => {
	const { children, backdrop, onBackgroundClick } = props;

	const el = document.createElement('div');

	useEffect(() => {
		modalRoot?.appendChild(el)
		return () => { modalRoot?.removeChild(el); }
	}, [el])

	return ReactDOM.createPortal(
		<div className="absolute inset-0 pointer-events-none">
			{backdrop && <div className="absolute inset-0" onClick={onBackgroundClick}></div>}
			{children}
		</div>,
		(modalRoot as HTMLElement)
	)
}

